module.exports = __webpack_public_path__ + "media/images/letter-W-2001a6ebc27c1243dc32c7809e89c38d.png";